import { FunctionComponent, useState } from 'react';
import useTranslate from '@hooks/useTranslate';
import componentContent from '../SpamUserCard.content.json';
import { Empty, Modal, Space, Spin, Table } from 'antd';
import css from './ComplaintsReasons.module.less';
import IUser from '@interfaces/IUser';
import reasons from '@stores/complaints-reason';
import { useStore } from 'effector-react';
import IStatus from '@interfaces/IStatus';
import { ColumnsType } from 'antd/lib/table';
import cn from 'classnames';
import moment from 'moment';
import getChatRecipientName from '@helpers/getChatRecipientName';

interface ComplaintsReasonProps {
  reasonsTable: any;
  isLoading: boolean;
  onOpen: (value: boolean) => void;
  user?: IUser | null;
  status?: IStatus;
  isPagination?: boolean;
}

const ComplaintsReason: FunctionComponent<ComplaintsReasonProps> = (props) => {
  const { pagination } = useStore(reasons);
  const [isOpened, setIsOpened] = useState(false);
  const content = useTranslate(componentContent);
  const { isLoading, onOpen, reasonsTable, user, status } = props;

  const handleOpen = () => {
    const nextValue = !isOpened;
    setIsOpened(nextValue);
    onOpen(nextValue);
  };

  const handleClose = () => {
    setIsOpened(false);
  };

  const columns: ColumnsType<any> = [
    {
      key: 'created',
      dataIndex: 'created',
      title: content.created,
      render: (value: string) => (value ? moment(value).format('DD.MM.YYYY HH:mm') : '-'),
    },
    {
      key: 'type',
      dataIndex: 'type',
      title: content.reason,
    },
    {
      key: 'text',
      dataIndex: 'text',
      title: content.comment,
    },
    {
      key: 'nickname',
      dataIndex: 'nickname',
      title: content.nickname,
    },
  ];

  const dataSource = (reasonsTable || []).map((item: any, index: number) => ({
    id: item.id || `${item.type}-${index}`,
    created: item.created || item.createdAt || item.claimDate,
    nickname: item.complainer?.nickname || getChatRecipientName(item),
    text: item.text || '-',
    type: item.type || '-',
  }));

  const count =
    (user && user.accountsComplained) ||
    (user && user.complainsCount) ||
    (user && user.accountClaimsCount) ||
    (status && status.claimsCount) ||
    0;

  return (
    <div>
      <Space onClick={count > 0 ? handleOpen : undefined}>
        <div
          className={cn(css.text, {
            [css.active]: count > 0,
          })}
        >
          {content.complaints}: {count}
        </div>
      </Space>

      <Modal
        visible={isOpened}
        title={
          <div>
            <div>{`${content.complaints}: ${count}`}</div>
            <div className={css.userNickname}>
              {user?.nickname && (
                <a
                  className={css.nicknameLink}
                  href={`/user-list/${user?.id}`}
                  target='_blank'
                  rel='noreferrer'
                >
                  {user?.nickname}
                </a>
              )}
            </div>
          </div>
        }
        footer={null}
        onCancel={handleClose}
        width={1000}
        destroyOnClose
        keyboard
      >
        <Spin spinning={isLoading}>
          {dataSource.length > 0 ? (
            <Table
              rowKey='id'
              dataSource={dataSource}
              columns={columns}
              pagination={{
                pageSizeOptions: ['3', '5', '10', '20'],
                showSizeChanger: true,
                position: ['topRight'],
                defaultPageSize: 3,
                current: pagination?.current,
                pageSize: pagination?.pageSize,
              }}
            />
          ) : (
            <Empty
              className={css.emptyContainer}
              imageStyle={{ height: '50px' }}
            />
          )}
        </Spin>
      </Modal>
    </div>
  );
};

export default ComplaintsReason;
